<template>
  <div class="body">
    <div class="language">
      <van-button class="switch" type="info" @click= 'enLogin'>English</van-button>
    </div>
    <div class="logo">
      <img src="../../assets/images/loginlogo.png">
    </div>
    <div class="login">
      <van-form>
        <van-field
        v-model="username"
        label="文本"
        placeholder="请输入手机号"
        />
        <van-field style="background-color: transparent;"
          v-model="sms"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
         <template #button>
            <van-button size="normal" type="primary" :disabled="disabled" @click="getCode">{{codeText}}</van-button>
          </template>
        </van-field>
      </van-form>
      <van-button size="small" class="btn" @click='loginClick'>登录</van-button>
      <div class="cl-register" @click="onRegister">注册账号</div>
    </div>

    <div style="position:absolute;bottom:30px;width:100%;color:#B28814;font-size:8px;font-weight: bold;">
      <div class="namediv2" >
        <span class="copyright1"><a target="_blank" style="display:inline-block;text-decoration: underline;color:#B28814;" href="http://beian.miit.gov.cn">辽ICP备：辽B-2-4-20080120-23</a> COPYRIGHT © 2019</span>
      </div>
      <div class="namediv2" >
        <span class="copyright1">WIFFA SHIPPINGTECH CO., LTD. All RIGHTS RESERVED</span>
      </div>
      <div class="namediv2" >
        <span class="copyright1">大连万发联合航贸科技有限公司</span>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      username: '',
      sms: '',
      codeText: '验证码',
      disabled: false
    }
  },
  components: {

  },
  created () {

  },
  mounted () {
    localStorage.setItem('locale', 'zh')
    this.$i18n.locale = localStorage.getItem('locale')
  },
  methods: {
    enLogin () {
      this.$router.push({
        name: 'loginEn'
      })
    },
    // 登录接口
    loginClick () {
      let mobile = this.username
      let smscode = this.sms
      if (!(/^1[3456789]\d{9}$/.test(mobile))) {
        this.$toast('手机号错误，请重新输入')
        return
      } else if (smscode.length != 6) {
        this.$toast('验证码错误，请重新输入')
        return
      }
      this.$axios.post('/clientUserLoginCn/login', {
        'mobile': mobile,
        'verifyCode': smscode
      })
        .then(response => {
          console.log('登录接口返回信息:↓↓↓')
          console.log(response)
          localStorage.setItem('locale', 'zh')
          this.$i18n.locale = localStorage.getItem('locale')
          let status = response.code
          let message = response.msg
          let data = response.data
          if (status == '0') {
            localStorage.setItem('userID', data.id)
            localStorage.setItem('mobile', data.mobile)
            localStorage.setItem('realName', data.realName)
            localStorage.setItem('userStatus', data.userStatus)
            localStorage.setItem('companyName', data.companyNameCn)
            this.userPermission()
          } else {
            this.$toast(message)
          }
        })
        .catch((error) => {
          console.log(error);
          this.abnormalSituation()
        });
    },
    // 获取验证码
    getCode () {
      let mobile = this.username

      if (!(/^1[3456789]\d{9}$/.test(mobile))) {
        this.$toast('请输入正确的手机号')
        return
      }

      this.$axios.get('/clientUserLoginCn/sendMobileCode', {
        params: {
          mobile: mobile
        }
      })
        .then(response => {
          console.log('登录===>获取验证码接口返回信息:↓↓↓')
          console.log(response)
          let status = response.code
          let message = response.msg
          if (status == '0') {
            if (!this.timer) {
              this.count = 120
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= 120) {
                  this.count--
                  this.codeText = this.count + 's'
                  this.disabled = true
                } else {
                  this.show = true
                  clearInterval(this.timer)
                  this.timer = null
                  this.codeText = '重新获取'
                  this.disabled = false
                }
              }, 1000)
            }
          } else {
            this.$toast(message)
          }
        })
        .catch(error => {
          console.log(error)
          this.abnormalSituation()
        })
    },
    // 获取用户权限
    userPermission () {
      this.$axios.get('/menu/userPermission', {
        params: {

        }
      })
        .then(response => {
          console.log('获取用户权限接口返回数据:↓↓↓')
          console.log(response)
          let status = response.code
          let message = response.msg
          let data = response.data
          if (status == 0) {
          // 缓存权限列表用于主页面显示tabbar判断
            localStorage.setItem('permissionList', data)
            // 根据权限列表决定登录后跳转的页面地址：ex用户拥有所有权限跳转到企业账户总览，用户只有个人账号权限跳转到个人账户总览
            // 判断顺序为tabbar显示顺序
            // 企业账户总览
            if (data && data.indexOf('user:company:account') != -1) {
              this.$router.push({
                name: 'accountmodel'
              })
              // 企业关联账号管理
            } else if (data && data.indexOf('user:company:accountmanage') != -1) {
              this.$router.push({
                name: 'managementmodel'
              })
              // 个人账户总览
            } else if (data && data.indexOf('user:person:account') != -1) {
              this.$router.push({
                name: 'personalmodel'
              })
            }
          } else if (status == -1) {
            this.$toast(message)
          }
        })
        .catch((error) => {
          console.log(error);
          this.abnormalSituation()
        });
    },
    onRegister () {
      this.$router.push({
        name: 'register',
        query: {

        }
      })
    }
  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
    outline: none;
    list-style: none;
    font-size: inherit;
    text-decoration: none;
    font-style: normal;
    resize: none;
    font-family: Microsoft YaHei!important;
  }
  html,body,#app{
    height: 100%;
  }
  .body{
    width: 100%;
    height: 100%;
    background: url(../../assets/images/clbackgroundimage.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
  }
  .login{
    width: 80%;
    top: 30%;
    margin-left:10%;
    padding: 20px;
    border-radius: 2px;
    position: fixed;
  }
  /deep/ .van-field__label{
    display: none!important;
  }
  /deep/ .van-field{

  }
  /deep/ .van-cell--center{
    padding-bottom: 10px;
    margin-top: 20px;
  }
  /deep/ .van-button--primary{
    background-color: #C9B25F;
    border: 1px solid #C9B25F;
  }
  /deep/ .van-cell{
    padding: 0;
  }
  .btn{
    width: 100%;
    height: 40px;
    margin: 60px auto 0;
    border-radius: 4px;
    background-color: #fd7d00;
    border: #fd7d00 solid 1px;
    color: white;
    display: block;
  }
  /deep/ .van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border: transparent solid 1px;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .cl-register{
    margin: 20px auto 5px;
    text-align: center;
    font-size: 14px;
    color: #fd7d00;
    text-decoration: underline
  }
  .logo{
    width: 216px;
    overflow: hidden;
    position: fixed;
    top: 20%;
    left: 50%;
    margin-left: -108px;
    text-align: center;
  }
  .logo img{
    width: auto;
    height: 35px;
    margin: auto;
  }
  .van-button--primary{
    padding: 0 15px;
  }
  /deep/ .van-field__control{
    padding-left: 10px;
    border: #C9B25F solid 1px;
    height: 40px;
    background-color: white;
  }
  /deep/ .van-button{
    height: 40px;
  }
  .language{
    margin-top: 20px;
    margin-right: 20px;
    float: right;
  }
  .switch{
    background-color: #fd7d00;
    border: #fd7d00 solid 1px;
    color: white;
    width: 80px;
    height: 35px;
    border-radius: 10px;
  }
  .namediv2{
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>
